// extracted by mini-css-extract-plugin
export default {"Clip":"DropdownSelector_Clip__HqX2q"};